/**
 * Password Strength Utilities
 * provide password strength checking functionality
 */

/**
 * Check password strength requirements
 * @param {string} password - password to check
 * @returns {Object} password strength object with boolean flags
 */
export const checkPasswordStrength = password => {
    if (!password) {
        return {
            length: false,
            uppercase: false,
            lowercase: false,
            number: false,
        }
    }

    return {
        length: password.length >= 8,
        uppercase: /[A-Z]/.test(password),
        lowercase: /[a-z]/.test(password),
        number: /[0-9]/.test(password),
    }
}

/**
 * Get password strength class name
 * @param {Object} strength - password strength object from checkPasswordStrength
 * @returns {string} strength class ('weak', 'medium', 'strong')
 */
export const getPasswordStrengthClass = strength => {
    if (!strength) return 'weak'

    const strengthCount = Object.values(strength).filter(Boolean).length
    if (strengthCount === 0) return 'weak'
    if (strengthCount <= 2) return 'medium'
    return 'strong'
}

/**
 * Check if password meets all requirements
 * @param {Object} strength - password strength object from checkPasswordStrength
 * @returns {boolean} true if all requirements are met
 */
export const isPasswordValid = strength => {
    if (!strength) return false
    return Object.values(strength).every(Boolean)
}
